import { IStatsCard } from '../../common';
import StatCard from './StatCard';
import { useTheme, Grid } from '../../base';

interface Props {
    stats: Array<IStatsCard>;
}
const StatsCardsRow = ({ stats = [] }: Props) => {
    const theme = useTheme();

    return (
        <Grid container spacing={3} sx={{ paddingBottom: theme.spacing(2) }}>
            {stats.map((stat, index) => (
                <Grid item xs={12} sm={6} md={3} key={index}>
                    <StatCard stats={stat} />
                </Grid>
            ))}
        </Grid>
    );
};

export default StatsCardsRow;
